import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import type { WithBoundArgs as WBA } from '@glint/template';
import type { EmberChangeset } from 'ember-changeset';
import ChangesetAlignedFieldsRadioGroup from './aligned-fields-radio-group.gts';
import ChangesetBasicRadioGroup from './basic-radio-group.gts';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    propertyName: string;
    conditionalValue: string | boolean;
    isReadOnly?: boolean;
  };
  Blocks: {
    default: [
      {
        BasicRadioGroup: WBA<
          typeof ChangesetBasicRadioGroup,
          'changeset' | 'propertyName' | 'isReadOnly'
        >;
        AlignedFieldsRadioGroup: WBA<
          typeof ChangesetAlignedFieldsRadioGroup,
          'changeset' | 'propertyName' | 'isReadOnly'
        >;
      },
      boolean
    ];
  };
}

export default class ConditionalRadioGroup extends Component<Signature> {
  get showConditionalBlock(): boolean {
    return (
      this.args.changeset.get(this.args.propertyName) ===
      this.args.conditionalValue
    );
  }

  <template>
    {{yield
      (hash
        BasicRadioGroup=(component
          ChangesetBasicRadioGroup
          changeset=@changeset
          propertyName=@propertyName
          isReadOnly=@isReadOnly
        )
        AlignedFieldsRadioGroup=(component
          ChangesetAlignedFieldsRadioGroup
          changeset=@changeset
          propertyName=@propertyName
          isReadOnly=@isReadOnly
        )
      )
      this.showConditionalBlock
    }}
  </template>
}
